module.exports = __webpack_public_path__ + "static/img/oouyan_hao_wu.a16a0a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beanCash/oouyan_hao_wu.png
// module id = xwcS
// module chunks = 1